import React from 'react';

const StatsVisualization = ({ className = "w-full h-48" }) => {
  return (
    <svg 
      className={className}
      viewBox="0 0 600 200" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id="chartGradient" x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="#8B5CF6" stopOpacity="0.3" />
          <stop offset="100%" stopColor="#8B5CF6" stopOpacity="0.8" />
        </linearGradient>
        <filter id="chartGlow">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge> 
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Chart Background */}
      <rect x="50" y="50" width="500" height="120" fill="#1F2937" rx="10" stroke="#374151" strokeWidth="1" />
      
      {/* Chart Grid Lines */}
      <line x1="50" y1="110" x2="550" y2="110" stroke="#374151" strokeWidth="1" opacity="0.5" />
      <line x1="50" y1="90" x2="550" y2="90" stroke="#374151" strokeWidth="1" opacity="0.5" />
      <line x1="50" y1="70" x2="550" y2="70" stroke="#374151" strokeWidth="1" opacity="0.5" />
      
      {/* Animated Chart Bars */}
      <g className="animate-pulse">
        {/* Bar 1 */}
        <rect x="80" y="120" width="30" height="40" fill="url(#chartGradient)" filter="url(#chartGlow)" className="animate-bounce" />
        <text x="95" y="140" textAnchor="middle" className="fill-white text-xs">100</text>
        
        {/* Bar 2 */}
        <rect x="130" y="100" width="30" height="60" fill="url(#chartGradient)" filter="url(#chartGlow)" className="animate-bounce" style={{animationDelay: '0.2s'}} />
        <text x="145" y="120" textAnchor="middle" className="fill-white text-xs">250</text>
        
        {/* Bar 3 */}
        <rect x="180" y="80" width="30" height="80" fill="url(#chartGradient)" filter="url(#chartGlow)" className="animate-bounce" style={{animationDelay: '0.4s'}} />
        <text x="195" y="100" textAnchor="middle" className="fill-white text-xs">500</text>
        
        {/* Bar 4 */}
        <rect x="230" y="60" width="30" height="100" fill="url(#chartGradient)" filter="url(#chartGlow)" className="animate-bounce" style={{animationDelay: '0.6s'}} />
        <text x="245" y="80" textAnchor="middle" className="fill-white text-xs">1000</text>
        
        {/* Bar 5 */}
        <rect x="280" y="40" width="30" height="120" fill="url(#chartGradient)" filter="url(#chartGlow)" className="animate-bounce" style={{animationDelay: '0.8s'}} />
        <text x="295" y="60" textAnchor="middle" className="fill-white text-xs">2000</text>
        
        {/* Bar 6 */}
        <rect x="330" y="30" width="30" height="130" fill="url(#chartGradient)" filter="url(#chartGlow)" className="animate-bounce" style={{animationDelay: '1s'}} />
        <text x="345" y="50" textAnchor="middle" className="fill-white text-xs">3000</text>
        
        {/* Bar 7 */}
        <rect x="380" y="20" width="30" height="140" fill="url(#chartGradient)" filter="url(#chartGlow)" className="animate-bounce" style={{animationDelay: '1.2s'}} />
        <text x="395" y="40" textAnchor="middle" className="fill-white text-xs">5000</text>
        
        {/* Bar 8 */}
        <rect x="430" y="10" width="30" height="150" fill="url(#chartGradient)" filter="url(#chartGlow)" className="animate-bounce" style={{animationDelay: '1.4s'}} />
        <text x="445" y="30" textAnchor="middle" className="fill-white text-xs">10000</text>
      </g>
      
      {/* Chart Labels */}
      <text x="95" y="180" textAnchor="middle" className="fill-gray-400 text-xs">Jan</text>
      <text x="145" y="180" textAnchor="middle" className="fill-gray-400 text-xs">Feb</text>
      <text x="195" y="180" textAnchor="middle" className="fill-gray-400 text-xs">Mar</text>
      <text x="245" y="180" textAnchor="middle" className="fill-gray-400 text-xs">Apr</text>
      <text x="295" y="180" textAnchor="middle" className="fill-gray-400 text-xs">May</text>
      <text x="345" y="180" textAnchor="middle" className="fill-gray-400 text-xs">Jun</text>
      <text x="395" y="180" textAnchor="middle" className="fill-gray-400 text-xs">Jul</text>
      <text x="445" y="180" textAnchor="middle" className="fill-gray-400 text-xs">Aug</text>
      
      {/* Y-axis Labels */}
      <text x="40" y="55" textAnchor="middle" className="fill-gray-400 text-xs">10K</text>
      <text x="40" y="75" textAnchor="middle" className="fill-gray-400 text-xs">8K</text>
      <text x="40" y="95" textAnchor="middle" className="fill-gray-400 text-xs">6K</text>
      <text x="40" y="115" textAnchor="middle" className="fill-gray-400 text-xs">4K</text>
      <text x="40" y="135" textAnchor="middle" className="fill-gray-400 text-xs">2K</text>
      <text x="40" y="155" textAnchor="middle" className="fill-gray-400 text-xs">0</text>
      
      {/* Floating Value Indicators */}
      <g className="animate-ping">
        <circle cx="95" cy="110" r="4" fill="#8B5CF6" />
        <text x="95" y="105" textAnchor="middle" className="fill-white text-xs font-bold">100</text>
      </g>
      
      <g className="animate-ping" style={{animationDelay: '0.5s'}}>
        <circle cx="445" cy="20" r="4" fill="#EC4899" />
        <text x="445" y="15" textAnchor="middle" className="fill-white text-xs font-bold">10K</text>
      </g>
      
      {/* Trend Line */}
      <path 
        d="M95 120 Q 195 100 295 60 Q 395 30 445 20" 
        stroke="#EC4899" 
        strokeWidth="3" 
        fill="none" 
        className="animate-pulse"
        strokeDasharray="5,5"
      />
    </svg>
  );
};

export default StatsVisualization;
